import { z } from 'zod';

import { CatalystTagSchema } from './enums';

/** Defensive ceiling: the wire list is otherwise unbounded (plan §6.5a). */
export const CATALYSTS_MAX = 32;

/**
 * Catalyst / news item (F15). Live v1 returns `catalysts: []`; synthetic
 * returns four seeded headlines (plan §6.5a).
 */
export const CatalystSchema = z.object({
  date: z.string().min(1).max(64),
  tag: CatalystTagSchema,
  headline: z.string().min(1).max(500),
});
export type Catalyst = z.infer<typeof CatalystSchema>;

/** Capped at CATALYSTS_MAX — see the constant for the rationale. */
export const CatalystsSchema = z.array(CatalystSchema).max(CATALYSTS_MAX);
export type Catalysts = z.infer<typeof CatalystsSchema>;
